import React from 'react';

const Tabs = ({
  active = '',
  tabs = [],
  onChange = () => {},
  children = () => '',
}) => (
  <div className="container-fluid tabs my-4">
    <div className="row justify-content-center">
      <div className="col-md-7">
        <div className="row justify-content-around">
          {tabs.map(({ key, label }) => (
            <div
              key={key}
              className="col-auto"
            >
              <a
                className="h4"
                onClick={() => onChange(key)}
              >
                <span className="small-sm">
                  {children({ key, label })}
                  <span
                    className={`pb-3 d-inline-block ${
                      active === key ? 'active' : ''
                    }`}
                  >{label}</span>
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Tabs;
